import { TimePoint } from "@hydrologiq/common/types/graph/timeseries"

export const calculateWeights = (weights: number[], usageLength: number) => {
  const newWeights = [...weights]
  if (usageLength > weights.length) {
    // Extend by repeating the middle value
    const start = weights[0]
    const middleValue = weights[1] // The repeatable middle weight
    const end = weights[weights.length - 1]
    
    const result = [start]
    // Fill middle with repeated values
    for (let i = 1; i < usageLength - 1; i++) {
      result.push(middleValue)
    }
    result.push(end)
    return result
  } else if (usageLength < weights.length) {
    // Truncate
    newWeights.splice(usageLength)
  }
  return newWeights
}

export const hydrogenForecast = (
  currentWeight: TimePoint,
  previousUsage: TimePoint[],
  threshold: number = 1,
  weighted: boolean = false,
  weights: number[] = [0.5, 3, 0.5]
): number | null => {
  const previousUsageThreshold = previousUsage.filter((value) => value.value >= threshold)

  if (previousUsageThreshold.length > 0) {
    const newWeights = calculateWeights(weights, previousUsageThreshold.length)

    const previousUsageAvg =
      previousUsageThreshold.reduce((previousValue, currentValue, index) => {
        return {
          ...currentValue,
          value: currentValue.value * (weighted && newWeights[index] ? newWeights[index] : 1) + previousValue.value,
        }
      }).value / previousUsageThreshold.length
    return Math.floor((currentWeight.value / previousUsageAvg) * 10) / 10
  }
  return null
}
